import { isErrorMobile100 } from "@/component/PageComponentMobile/error"
import { serviceFilterGoodsTagAndBrand,GoodsTagsBrand } from './serviceFilterGoodsTagAndBrand'
import { LabelItem } from "../Common/LabelItem"
import { FilterList } from "../Common/FilterList"
import React from 'react'
import { useRequest } from "ahooks"

interface FilterGoodsTagAndBrandMobileProps {
  type: 'tag'|'brand',
  placeholder: string
  onChange(value:any[]):void
  value?:any[]
}

export const FilterGoodsTagAndBrandMobile = (props:FilterGoodsTagAndBrandMobileProps)=>{
  const { placeholder ,type} = props
  const [data,setData] = React.useState<GoodsTagsBrand['data']>()
  const [visible,setVisible] = React.useState(false)
  
  let {run:getGoodsTagBrand,loading} = useRequest(async()=>{
    let res = await serviceFilterGoodsTagAndBrand()
    if(isErrorMobile100(res)){
      return
    }
    setData(res.data.data)
  },{manual:true})
  React.useEffect(()=>{
    if(visible){
      getGoodsTagBrand()
    }
  },[visible])
  let dataSource = React.useMemo(()=>{
    return type == 'brand' ? data?.brand.list.map(item => ({ label: item.brand_name,value: item.brand_id })) : data?.tags.map(item => ({ label: item.tags_name,value: item.tags_id }))
  },[data])
  return <div>
    <LabelItem
      label={placeholder}
      value={ props.value}    
      options={dataSource}
      onClick={()=>setVisible(true)} 
    ></LabelItem>
    <FilterList
      visible={visible}
      loading={loading}
      value={props.value}
      headerText={placeholder}
      dataSource={dataSource || []}
      onChange={props.onChange}
      onClose={ ()=>setVisible(false) }
    />
  </div>
}